import { bool, func, oneOf } from 'prop-types';
import React, { Component } from 'react';
import { GoCloudDownload, GoEye, GoTrashcan } from 'react-icons/go';

import { attachmentShape } from '../../prop-types';
import { tapFlashError, tapFlashSuccess } from '../../utils/flash';
import FileDownloader from '../FileDownloader';
import FilePreview from '../FilePreview';
import TimeStamp from '../TimeStamp/TimeStamp';

function getFileType(fileFormat) {
  // strip the leading dot from the file format value, e.g. '.jpg' or '.pdf'
  return fileFormat.replace(/^\./, '').toUpperCase();
}

export default class File extends Component {
  onDeleteFile = () => {
    const { file, onDeleteFile } = this.props;
    onDeleteFile({ id: file.id })
      .then(() => this.props.onDeleteFileSuccess(file))
      .then(tapFlashSuccess(`${file.name} deleted successfully`))
      .catch(tapFlashError());
  };

  onGetFile = () => {
    const { file, onGetFile } = this.props;
    return onGetFile({ id: file.id })
      .then(tapFlashSuccess(`${file.name} downloaded successfully`))
      .catch(tapFlashError());
  };

  render() {
    const { name, fileFormat, created, id } = this.props.file;
    const { onGetFile, view, onDeleteFile, noDeleteOption } = this.props;
    const isDefaultView = view === 'default';
    return (
      <div className="p-2 border rounded" title={name}>
        <h4 className="text-muted text-truncate font-size-small font-weight-semi-bold mb-1">
          {name}
        </h4>
        {isDefaultView && (
          <div className="d-flex justify-content-between font-size-tiny">
            <span className="font-weight-semi-bold" data-qa-field="file-type">
              {getFileType(fileFormat)}
            </span>
            <TimeStamp>{created}</TimeStamp>
          </div>
        )}
        <div className="d-flex align-items-center font-size-small justify-content-end">
          <FilePreview
            tag={GoEye}
            title={name}
            additionalButtonProps={{
              className: 'font-size-small cursor-pointer',
              title: 'Preview',
            }}
            queryFn={() => onGetFile({ id })}
          />
          <FileDownloader
            tag="span"
            onGetFile={this.onGetFile}
            className="ml-2"
            onFileDownloadSuccess={this.props.onFileDownloadSuccess}
          >
            <GoCloudDownload />
          </FileDownloader>
          {onDeleteFile && !noDeleteOption && (
            <GoTrashcan
              title="Delete"
              className="cursor-pointer ml-2"
              onClick={this.onDeleteFile}
            />
          )}
        </div>
      </div>
    );
  }
}

File.propTypes = {
  onGetFile: func.isRequired,
  onDeleteFile: func,
  onDeleteFileSuccess: func,
  onFileDownloadSuccess: func,
  file: attachmentShape.isRequired,
  view: oneOf(['default', 'compact']),
  noDeleteOption: bool,
};

File.defaultProps = {
  view: 'default',
  onDeleteFile: undefined,
  onFileDownloadSuccess() {},
  onDeleteFileSuccess() {},
  noDeleteOption: false,
};
